// extracted by mini-css-extract-plugin
export default {"tabs":"tabs-tV4M0","tab":"tab-LrG7n"};